import { render, staticRenderFns } from "./CenterLecture.vue?vue&type=template&id=18d5ce02&"
import script from "./CenterLecture.vue?vue&type=script&lang=js&"
export * from "./CenterLecture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports